import React from "react";

const Forbidden = () => {
  return (
    <div className="forbidden-container">
      <i className="forbidden-icon fa fa-exclamation-triangle" />
      <h1>{`Your account does not have the correct access to use this tool.`}</h1>
      <h2>
        {
          `Please request your local IT department to grant access to the 'CPADMIN NMSC User' 
          or 'CPADMIN TME User' role.`
        }
      </h2>
    </div>
  );
};

export default Forbidden;
